import axios from "axios";
import { getBarGraph } from "@redux/actions/homePage-actions";
import { getUpcomingTourPlan } from "@redux/actions/upcomingTourPlan-actions";
import { sessionExpireTimeout } from "@redux/actions/utility-actions";
import { BASE_URL } from "../../variables";

export const addNewTourPlanApi = (allData) => async (dispatch) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/NTP_POST/`,
    method: "post",
    data: {
      MTP: allData,
    },
  };

  try {
    const response = await axios(options);
    if (response?.status === 200) {
      dispatch(getBarGraph());
      dispatch(getUpcomingTourPlan());
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    if (err.code === "ERR_NETWORK") {
      sessionExpireTimeout(dispatch);
    } else {
      return {
        success: false,
        msg: "Somthing Went Wrong..!!",
      };
    }
  }
};
